/* TMFv116: custom site search.
   Fuzzy + synonyms + recency + related posts, plus:
   - live term suggestions built from titles, tags and synonyms as you type
   - prefix ranking so one or two letters return something sane
   - products and free tools are searchable, not just articles
   - keyboard navigation (up/down/enter/escape) and match highlighting
   Renders into the header dropdown (#tmf-search-results) and /search (#tmf-search-page). */
(function () {
  if (window.__tmfSearch) return;
  window.__tmfSearch = true;

  var INDEX_URL = '/blogs/aiformoms?view=search-index';
  var FUSE_URL = window.__tmfFuseUrl;
  var SKIP_TAG = 'AI Prompts & Systems';

  /* Products and free tools. Held here rather than in the blog index so a
     shopping query always resolves, even before the article index loads. */
  var SHELF = [
    { title: 'The Collection', url: '/pages/the-collection', meta: '45 systems \u00b7 $27', kind: 'shop',
      words: 'collection systems home work money school morning lunch carpool budget subscriptions raise review fall reset finish strong well spent' },
    { title: 'The Camera Roll', url: '/pages/the-camera-roll', meta: '40 photo-first systems \u00b7 $27', kind: 'shop',
      words: 'camera roll photo photos picture pictures fridge pantry paperwork pile room rooms design decorate bathroom backyard closet outfit suitcase dorm' },
    { title: 'Act As If', url: '/pages/shop', meta: '20 expert-mode systems \u00b7 $27', kind: 'shop',
      words: 'act as if expert experts coo cfo chief of staff coach recruiter negotiator strategist cmo sales brand stylist parenting travel decision future self simplifier' },
    { title: 'All three, together', url: '/pages/shop', meta: '105 systems \u00b7 $39', kind: 'shop',
      words: 'bundle all three everything deal value cheapest save' },
    { title: 'The Prompt Library', url: '/pages/prompt-library', meta: 'Free', kind: 'free',
      words: 'prompt prompts library free copy paste browse' },
    { title: 'The AI Check-Up', url: '/pages/ai-check-up', meta: 'Two minutes', kind: 'free',
      words: 'quiz check up checkup score test where do i start level' },
    { title: 'The Starter Checklist', url: '/pages/free-guide', meta: 'Free', kind: 'free',
      words: 'starter checklist beginner free guide first steps' },
    { title: 'Start Here', url: '/pages/start-here', meta: 'New to AI', kind: 'free',
      words: 'start here begin new beginner first time how do i start' }
  ];

  /* Words moms actually type -> words the posts actually use. */
  var SYN = {
    dinner: ['meal', 'recipe', 'cooking', 'food', 'menu'],
    lunch: ['meal', 'school', 'food', 'recipe'],
    breakfast: ['meal', 'recipe', 'food'],
    food: ['meal', 'recipe', 'grocery', 'cooking'],
    grocery: ['shopping', 'meal', 'list'],
    kids: ['child', 'children', 'toddler', 'teen', 'family', 'school'],
    kid: ['child', 'children', 'family'],
    child: ['kids', 'parenting', 'family'],
    baby: ['newborn', 'toddler', 'sleep'],
    school: ['homework', 'kids', 'lunch', 'teacher', 'learning'],
    money: ['budget', 'income', 'finance', 'business', 'side hustle'],
    budget: ['money', 'finance', 'spending'],
    business: ['work', 'entrepreneur', 'side hustle', 'career', 'income'],
    work: ['career', 'job', 'business', 'productivity'],
    job: ['career', 'work', 'resume'],
    home: ['house', 'cleaning', 'organize', 'chores'],
    clean: ['cleaning', 'chores', 'declutter', 'organize'],
    organize: ['organization', 'declutter', 'planning', 'systems'],
    schedule: ['calendar', 'planning', 'routine', 'time'],
    time: ['schedule', 'routine', 'productivity', 'planning'],
    vacation: ['travel', 'trip', 'holiday', 'packing'],
    trip: ['travel', 'vacation', 'road trip', 'packing'],
    travel: ['trip', 'vacation', 'packing'],
    outfit: ['style', 'wardrobe', 'clothes', 'fashion'],
    clothes: ['style', 'wardrobe', 'outfit', 'capsule'],
    style: ['outfit', 'wardrobe', 'fashion', 'beauty'],
    workout: ['fitness', 'exercise', 'wellness', 'health'],
    exercise: ['workout', 'fitness', 'wellness'],
    health: ['wellness', 'fitness', 'sleep', 'stress'],
    stress: ['wellness', 'burnout', 'mental', 'calm'],
    sleep: ['bedtime', 'routine', 'wellness'],
    party: ['birthday', 'celebration', 'holiday', 'planning'],
    birthday: ['party', 'gift', 'celebration'],
    gift: ['gifts', 'present', 'holiday', 'birthday'],
    christmas: ['holiday', 'gift', 'december'],
    holiday: ['christmas', 'thanksgiving', 'gift', 'celebration'],
    chatgpt: ['ai', 'prompt', 'tool'],
    prompt: ['prompts', 'chatgpt', 'template'],
    prompts: ['prompt', 'library', 'chatgpt'],
    beginner: ['learn', 'start', 'basics', 'new to ai'],
    learn: ['beginner', 'basics', 'guide', 'explained'],
    garden: ['plants', 'yard', 'backyard', 'outdoor'],
    plants: ['garden', 'yard'],
    date: ['marriage', 'partner', 'relationship', 'husband'],
    husband: ['partner', 'marriage', 'relationship'],
    photo: ['photos', 'pictures', 'image', 'memories'],
    video: ['reels', 'content', 'instagram'],
    write: ['writing', 'email', 'caption', 'content'],
    email: ['writing', 'inbox', 'newsletter'],
    resume: ['job', 'career', 'interview'],
    interview: ['job', 'career', 'resume']
  };

  var STOP = {a:1,an:1,the:1,and:1,or:1,for:1,with:1,without:1,your:1,you:1,my:1,me:1,i:1,to:1,of:1,in:1,on:1,at:1,is:1,it:1,its:1,that:1,this:1,these:1,those:1,from:1,what:1,how:1,why:1,who:1,when:1,are:1,was:1,were:1,be:1,been:1,but:1,not:1,can:1,could:1,all:1,out:1,up:1,do:1,does:1,did:1,has:1,have:1,had:1,into:1,about:1,than:1,then:1,they:1,them:1,their:1,will:1,just:1,one:1,two:1,three:1,more:1,most:1,some:1,any:1,every:1,each:1,we:1,us:1,our:1,she:1,her:1,he:1,his:1,if:1,so:1,as:1,by:1,vs:1};

  var state = { index: null, fuse: null, loading: null, vocab: null };

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }

  function tokens(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9\s-]/g, ' ').split(/\s+/).filter(Boolean);
  }

  /* Vocabulary for the suggestion row: tags and product names weigh most,
     then title words, then the synonym keys people actually type. */
  function buildVocab() {
    var freq = {};
    function add(term, w) {
      term = String(term || '').toLowerCase().trim();
      if (!term || term.length < 3 || STOP[term]) return;
      if (/^[0-9]+$/.test(term)) return;
      freq[term] = (freq[term] || 0) + w;
    }
    SHELF.forEach(function (p) { add(p.title.replace(/^the\s+/i, ''), 40); });
    state.index.forEach(function (it) {
      (it.tags || []).forEach(function (t) { if (t !== SKIP_TAG) add(t, 12); });
      tokens(it.title).forEach(function (w) { add(w, 3); });
    });
    Object.keys(SYN).forEach(function (k) { add(k, 8); });
    state.vocab = Object.keys(freq).map(function (t) { return { t: t, w: freq[t] }; })
      .sort(function (a, b) { return b.w - a.w; });
  }

  function getIndex() {
    if (state.index) return Promise.resolve(state.index);
    if (state.loading) return state.loading;
    var cached = null;
    try {
      var raw = sessionStorage.getItem('tmf-search-index');
      if (raw) { cached = JSON.parse(raw); if (Date.now() - cached.t > 1800000) cached = null; }
    } catch (e) {}
    var p = Promise.all([
      window.Fuse ? Promise.resolve() : loadScript(FUSE_URL),
      cached ? Promise.resolve(cached.data) : fetch(INDEX_URL, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var data = JSON.parse(t.trim());
        try { sessionStorage.setItem('tmf-search-index', JSON.stringify({ t: Date.now(), data: data })); } catch (e) {}
        return data;
      })
    ]).then(function (r) {
      var data = r[1];
      state.index = data.items.map(function (it, i) { it.id = i; it.tagText = (it.tags || []).join(' '); return it; });
      state.fuse = new Fuse(state.index, {
        keys: [
          { name: 'title', weight: 4 },
          { name: 'tagText', weight: 3 },
          { name: 'excerpt', weight: 2 },
          { name: 'body', weight: 1 }
        ],
        includeScore: true,
        ignoreLocation: true,
        threshold: 0.38,
        minMatchCharLength: 1,
        useExtendedSearch: false
      });
      buildVocab();
      return state.index;
    });
    state.loading = p;
    return p;
  }

  /* ---- suggestions ------------------------------------------------------ */

  function suggest(q, n) {
    if (!state.vocab) return [];
    var ql = q.toLowerCase().trim();
    if (!ql) return [];
    var parts = ql.split(/\s+/);
    var last = parts[parts.length - 1];
    var head = parts.slice(0, -1).join(' ');
    if (!last) return [];
    var starts = [], contains = [];
    for (var i = 0; i < state.vocab.length; i++) {
      var t = state.vocab[i].t;
      if (t === last) continue;
      if (t.indexOf(last) === 0) starts.push(t);
      else if (last.length >= 3 && t.indexOf(last) > 0) contains.push(t);
      if (starts.length >= n * 3) break;
    }
    var out = [], seen = {};
    starts.concat(contains).forEach(function (t) {
      var phrase = (head ? head + ' ' + t : t).trim();
      if (phrase === ql || seen[phrase]) return;
      seen[phrase] = 1;
      out.push(phrase);
    });
    return out.slice(0, n);
  }

  /* ---- shelf (products + free tools) ------------------------------------ */

  function shelfHits(q) {
    var ql = q.toLowerCase().trim();
    if (ql.length < 2) return [];
    var qt = tokens(ql);
    return SHELF.map(function (p) {
      var hay = (p.title + ' ' + p.words).toLowerCase();
      var score = 0;
      if (hay.indexOf(ql) > -1) score += 6;
      if (p.title.toLowerCase().indexOf(ql) === 0) score += 6;
      qt.forEach(function (w) {
        if (STOP[w]) return;
        if (hay.indexOf(w) > -1) score += (w.length >= 4 ? 2 : 1);
      });
      return { p: p, score: score };
    }).filter(function (r) { return r.score >= 4; })
      .sort(function (a, b) { return b.score - a.score; })
      .slice(0, 3).map(function (r) { return r.p; });
  }

  /* ---- article search --------------------------------------------------- */

  function expand(q) {
    var words = q.toLowerCase().split(/\s+/).filter(Boolean);
    var out = [];
    words.forEach(function (w) {
      var s = SYN[w] || SYN[w.replace(/s$/, '')] || [];
      s.forEach(function (alt) { out.push(q.toLowerCase().replace(w, alt)); });
    });
    return out.filter(function (v, i, a) { return a.indexOf(v) === i && v !== q.toLowerCase(); }).slice(0, 6);
  }

  function recency(item) {
    if (!item.date) return 0;
    var days = (Date.now() / 1000 - item.date) / 86400;
    if (days < 0) days = 0;
    return Math.max(0, 0.14 * (1 - days / 240));
  }

  /* Straight prefix work. Fuse alone is mushy at one or two characters, so a
     title that literally starts with what you typed jumps the queue. */
  function prefixBonus(item, q) {
    var t = String(item.title || '').toLowerCase();
    var tg = String(item.tagText || '').toLowerCase();
    if (t.indexOf(q) === 0) return 0.30;
    if (t.indexOf(' ' + q) > -1) return 0.20;
    if (t.indexOf(q) > -1) return 0.12;
    if (tg.indexOf(q) > -1) return 0.08;
    return 0;
  }

  function search(q, limit) {
    var ql = q.toLowerCase().trim();
    var best = {};
    function absorb(results, penalty) {
      results.forEach(function (r) {
        var sc = r.score + penalty;
        if (best[r.item.id] === undefined || sc < best[r.item.id]) best[r.item.id] = sc;
      });
    }
    absorb(state.fuse.search(q), 0);
    expand(q).forEach(function (alt) { absorb(state.fuse.search(alt), 0.08); });

    /* one and two character queries: pure prefix, Fuse is noise at that length */
    if (ql.length <= 2) {
      state.index.forEach(function (it) {
        if (prefixBonus(it, ql) >= 0.20 && best[it.id] === undefined) best[it.id] = 0.5;
      });
    }

    var list = Object.keys(best).map(function (id) {
      var it = state.index[id];
      return { item: it, score: best[id] - recency(it) - prefixBonus(it, ql) };
    }).sort(function (a, b) { return a.score - b.score; });
    return list.slice(0, limit).map(function (r) { return r.item; });
  }

  function related(hits, exclude, n) {
    var tags = {};
    hits.slice(0, 3).forEach(function (h) { (h.tags || []).forEach(function (t) { if (t !== SKIP_TAG) tags[t] = 1; }); });
    var seen = {}; exclude.forEach(function (h) { seen[h.id] = 1; });
    return state.index.filter(function (it) {
      return it.type === 'article' && !seen[it.id] && (it.tags || []).some(function (t) { return tags[t]; });
    }).sort(function (a, b) { return b.date - a.date; }).slice(0, n);
  }

  function latest(n) {
    return state.index.filter(function (it) { return it.type === 'article'; })
      .sort(function (a, b) { return b.date - a.date; }).slice(0, n);
  }

  /* ---- rendering -------------------------------------------------------- */

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function mark(text, q) {
    var safe = esc(text);
    var ws = String(q || '').toLowerCase().split(/\s+/).filter(function (w) { return w.length >= 2 && !STOP[w]; });
    if (!ws.length) return safe;
    ws.sort(function (a, b) { return b.length - a.length; });
    var re = new RegExp('(' + ws.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  }

  function pillar(it) {
    var t = (it.tags || []).filter(function (x) { return x !== SKIP_TAG; });
    return t[0] || (it.tags || [])[0] || '';
  }

  function card(it, q) {
    if (it.type === 'page') {
      return '<a href="' + esc(it.url) + '" class="tmf-sr-page"><span class="tmf-sr-eyebrow">Free tool</span><span class="tmf-sr-title">' + mark(it.title, q) + '</span></a>';
    }
    return '<a href="' + esc(it.url) + '" class="tmf-sr-card">' +
      (it.image ? '<span class="tmf-sr-img"><img src="' + esc(it.image) + '" alt="" loading="lazy"></span>' : '<span class="tmf-sr-img tmf-sr-img--blank"></span>') +
      '<span class="tmf-sr-body"><span class="tmf-sr-eyebrow">' + esc(pillar(it)) + '</span><span class="tmf-sr-title">' + mark(it.title, q) + '</span>' +
      (it.excerpt ? '<span class="tmf-sr-excerpt">' + esc(it.excerpt) + '</span>' : '') + '</span></a>';
  }

  function shelfCard(p, q) {
    return '<a href="' + esc(p.url) + '" class="tmf-sr-shelf">' +
      '<span class="tmf-sr-shelf-name">' + mark(p.title, q) + '</span>' +
      '<span class="tmf-sr-shelf-meta">' + esc(p.meta) + '</span></a>';
  }

  function group(label, items, q) {
    if (!items.length) return '';
    return '<div class="tmf-sr-group"><p class="tmf-sr-label">' + esc(label) + '</p><div class="tmf-sr-grid">' +
      items.map(function (it) { return card(it, q); }).join('') + '</div></div>';
  }

  function shelfGroup(items, q) {
    if (!items.length) return '';
    return '<div class="tmf-sr-group tmf-sr-group--shelf"><div class="tmf-sr-shelf-row">' +
      items.map(function (p) { return shelfCard(p, q); }).join('') + '</div></div>';
  }

  function suggRow(list) {
    if (!list.length) return '';
    return '<div class="tmf-sr-sugg">' + list.map(function (s) {
      return '<button type="button" class="tmf-sr-chip" data-q="' + esc(s) + '">' + esc(s) + '</button>';
    }).join('') + '</div>';
  }

  function render(el, q, mode) {
    var lim = mode === 'page' ? 48 : 6;
    var qq = (q || '').trim();

    if (qq.length < 1) {
      el.innerHTML = group('Latest', latest(mode === 'page' ? 9 : 4), '');
      return;
    }

    var html = '';
    if (mode !== 'page') html += suggRow(suggest(qq, 5));
    html += shelfGroup(shelfHits(qq), qq);

    var hits = search(qq, lim);
    if (hits.length) {
      html += group(mode === 'page' ? 'Results for "' + qq + '"' : 'Reading', hits, qq);
      html += group('More like this', related(hits, hits, 3), '');
    } else if (!html.replace(/<div class="tmf-sr-sugg">[\s\S]*?<\/div>/, '').trim()) {
      html += '<p class="tmf-sr-empty">Nothing matched "' + esc(qq) + '" exactly. Here is what comes closest.</p>';
      html += group('Closest matches', latest(mode === 'page' ? 6 : 4), '');
    }
    el.innerHTML = html;
  }

  /* ---- wiring ----------------------------------------------------------- */

  function bind(input, out, mode) {
    var timer = null, lastQ = null, cursor = -1;

    function items() {
      return Array.prototype.slice.call(out.querySelectorAll('.tmf-sr-chip, a[href]'));
    }
    function highlight() {
      var list = items();
      list.forEach(function (n, i) { n.classList.toggle('is-active', i === cursor); });
      if (cursor > -1 && list[cursor] && list[cursor].scrollIntoView) {
        list[cursor].scrollIntoView({ block: 'nearest' });
      }
    }
    function run() {
      var q = input.value;
      if (q === lastQ) return; lastQ = q; cursor = -1;
      getIndex().then(function () { render(out, q, mode); }).catch(function () {
        out.innerHTML = '<p class="tmf-sr-empty">Search is warming up. Try again in a second.</p>';
      });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 70); });
    input.addEventListener('focus', function () { getIndex().then(function () { if (!out.innerHTML) render(out, input.value, mode); }); });

    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!list.length) return;
        e.preventDefault();
        cursor += (e.key === 'ArrowDown' ? 1 : -1);
        if (cursor < -1) cursor = list.length - 1;
        if (cursor >= list.length) cursor = -1;
        highlight();
      } else if (e.key === 'Enter') {
        if (cursor > -1 && list[cursor]) {
          e.preventDefault();
          list[cursor].click();
        }
      } else if (e.key === 'Escape') {
        cursor = -1; highlight();
      }
    });

    /* a suggestion chip fills the box and searches again */
    out.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.tmf-sr-chip') : null;
      if (!chip) return;
      e.preventDefault();
      input.value = chip.getAttribute('data-q');
      input.focus();
      run();
    });

    if (mode === 'page') run();
    return run;
  }

  function init() {
    var hdr = document.querySelector('#tmf-search-form input[name="q"]');
    var hdrOut = document.getElementById('tmf-search-results');
    if (hdr && hdrOut) bind(hdr, hdrOut, 'dropdown');

    var pg = document.getElementById('tmf-search-page');
    var pgIn = document.querySelector('#tmf-search-page-form input[name="q"]');
    if (pg && pgIn) {
      var params = new URLSearchParams(location.search);
      if (params.get('q')) pgIn.value = params.get('q');
      bind(pgIn, pg, 'page');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
